// extracted by mini-css-extract-plugin
module.exports = {"Container":"ForWho_Container__19IBs","Workers":"ForWho_Workers__3hOmF","Worker":"ForWho_Worker__1q9an"};